import { tagNameFor } from "./tagName";
import type {
  ComponentDefinition,
  ComponentDescriptor,
  ComponentName,
  ComponentRegistryMap,
  InertTagName,
} from "./types";

export function rwc<K extends keyof ComponentRegistryMap>(
  name: K,
  definition: ComponentDefinition<ComponentRegistryMap[K]["props"]>,
): ComponentDescriptor;

export function rwc<K extends InertTagName>(name: K): ComponentDescriptor;

export function rwc(
  name: string,
  definition?: ComponentDefinition,
): ComponentDescriptor {
  return { name, tagName: tagNameFor(name), definition };
}

export class ComponentManager {
  private components = new Map<string, ComponentDefinition | undefined>();

  register(...descriptors: ComponentDescriptor[]): void {
    descriptors.forEach((descriptor) => {
      this.components.set(descriptor.name, descriptor.definition);
    });
  }

  getDefinition(name: string): ComponentDefinition | undefined {
    return this.components.get(name);
  }

  has(name: string | undefined): name is ComponentName {
    return name !== undefined && !!this.components.get(name);
  }

  names(): (ComponentName | InertTagName)[] {
    return [...this.components.keys()] as (ComponentName | InertTagName)[];
  }
}

export const componentManager = new ComponentManager();
